import ShipHeading from './ShipHeading'

export default ShipHeading
